<template>
  <div class="talk_container">
    <div class="talk_box">
      <div class="talk_left">
        <div class="info_box">
          <div class="info_top">
<!--            <img-->
<!--              :src="-->
<!--                headerImg-->
<!--                  ? imgurl + headerImg-->
<!--                  : '../../assets/img/home/img8.png'-->
<!--              "-->
<!--              alt-->
<!--            />-->

<!--            <img src="../../assets/img/talk/img_4_1.png" alt/>-->
            <img v-if="userInfo.sex==1" src="../../assets/img/home/boy.jpg" alt/>
            <img v-else-if="userInfo.sex==0" src="../../assets/img/home/girl.jpg" alt/>

            <div class="info_right">
              <div>
                {{ userInfo.trueName }}
                <img src="../../assets/img/talk/icon_nv.png" alt />
              </div>
              <!-- <div>河南</div> -->
              <div>专业 : {{ userInfo.majorName }}</div>
            </div>
          </div>
          <div class="info_btm">
            <div
              class="btm_item"
              style="cursor: pointer"
              @click="getItem($event, 0)"
            >
              <img src="../../assets/img/talk/icon_4_1.png" alt />
              <div>我的帖子</div>
              <!-- <div>22</div>
              <div class="badeg">22</div>-->
            </div>
            <div class="line"></div>
            <div
              class="btm_item"
              style="cursor: pointer"
              @click="getItem($event, 1)"
            >
              <img src="../../assets/img/talk/icon_4_2.png" alt />
              <div>我的回答</div>
              <!-- <div>22</div>
              <div class="badeg">22</div>-->
            </div>
            <div class="line"></div>
            <div
              class="btm_item"
              style="cursor: pointer"
              @click="getItem($event, 2)"
            >
              <img src="../../assets/img/talk/icon_4_3.png" alt />
              <div>我的消息</div>
              <!-- <div>22</div>
              <div class="badeg">22</div>-->
            </div>
          </div>
        </div>
        <!-- 热门帖子 -->
        <div v-if="navBarActive == -1" class="hot_list">
          <div class="hot_top">热门帖子</div>
          <div class="hot_body">
            <!-- 前三 -->
            <div
              class="first"
              @click="getChild(3)"
              v-for="(item, index) in hotList"
              :key="item.id"
            >
              <div class="hot_left">
                <div class="index">{{ index + 1 }}</div>
                <span class="hot_title">{{ item.title }}</span>
              </div>
              <div class="hot_right">
                {{ (item.addtime * 1000) | dateFormat }}
              </div>
            </div>
            <!-- 后七 -->
            <div
              class="first"
              @click="getChild(3)"
              v-for="(item, index) in hotList2"
              :key="item.id"
            >
              <div class="hot_left">
                <div class="index index2">{{ index + 4 }}</div>
                <span class="hot_title">{{ item.title }}</span>
              </div>
              <div class="hot_right">
                {{ (item.addtime * 1000) | dateFormat }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="talk_right">
        <Talk
          v-if="navBarActive == -1"
          @func="getMsgFormSon"
          @child-event="getChild"
        ></Talk>
        <!-- 我的帖子 -->
        <MyTie
          v-if="navBarActive == 0"
          @child-event="getChild"
          :name="itemName"
        ></MyTie>
        <!-- 我的回答 -->
        <MyAnswer
          v-if="navBarActive == 1"
          @child-event="getChild"
          :name="itemName"
        ></MyAnswer>
        <!-- 我的消息 -->
        <MyMsg
          v-if="navBarActive == 2"
          @child-event="getChild"
          :name="itemName"
        ></MyMsg>
        <!-- 帖子详情 -->
        <TalkDetail
          v-if="navBarActive == 3"
          @child-event="getChild"
        ></TalkDetail>
      </div>
    </div>
  </div>
</template>

<script>
import store from "store";
import { forumIndex } from "../../assets/js/api.js";
import MyTie from "@/components/talk/myTie";
import MyAnswer from "@/components/talk/myAnswer";
import MyMsg from "@/components/talk/myMsg";
import Talk from "@/components/talk/talk";
import TalkDetail from "@/components/talk/talkDetail";
export default {
  components: {
    MyTie,
    MyAnswer,
    MyMsg,
    Talk,
    TalkDetail,
  },
  data() {
    return {
      imgurl: "http://education.hnzye.cn",
      navBarActive: -1,
      type: 1,
      itemName: "",
      userInfo: "",
      headerImg: "",
      hotList: [],
      hotList2: [],
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("users"));
    this.headerImg = store.get("header_img");
    window.scroll(0, 0);
  },
  methods: {
    getMsgFormSon(data) {

      this.hotList = data.slice(0, 3);
      this.hotList2 = data.slice(3);
    },
    getItem(e, i) {
      // this.navBarItem = e.target.innerHTML;
      // this.itemName = e.target.innerHTML;
      if (i == 0) {
        this.itemName = "我的帖子";
      } else if (i == 1) {
        this.itemName = "我的回答";
      } else if (i == 2) {
        this.itemName = "我的消息";
      }
      console.log(this.itemName);
      this.navBarActive = i;
    },
    getChild(e) {
      this.navBarActive = e;
    },
  },
};
</script>

<style lang="less" scoped>
.talk_container {
  background-color: #f2f2f2;
  min-height: calc(100vh - 241px);
  padding: 80px 0;
  box-sizing: border-box;
}

.talk_box {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  .talk_left {
    .info_box {
      width: 370px;
      height: 420px;
      background: url("../../assets/img/talk/bg_4_1.png") no-repeat;
      background-size: 100%, 100%;
      padding: 30px;
      box-sizing: border-box;

      .info_top {
        display: flex;
        align-items: center;
        margin-top: 20px;

        img {
          width: 90px;
          height: 90px;
          border-radius: 50%;
          margin-right: 20px;
        }

        .info_right {
          font-size: 18px;
          color: #fff;
          line-height: 1.8;

          div:nth-child(1) {
            font-size: 24px;
          }

          img {
            width: 12px;
            height: 10px;
            transform: rotate(-45deg);
          }
        }
      }

      .line {
        width: 1px;
        height: 88px;
        border-left: 1px dashed #ededed;
      }

      .info_btm {
        display: flex;
        justify-content: space-around;
        margin-top: 60px;
        color: #fff;
        font-size: 14px;

        .btm_item {
          position: relative;
          text-align: center;

          // cursor: pointer;
          img {
            width: 34px;
            height: 34px;
          }

          div {
            margin: 10px 0;
          }

          .badeg {
            position: absolute;
            top: -20px;
            right: -10px;
            padding: 10px 8px;
            line-height: 1px;
            box-sizing: border-box;
            border-radius: 10px;
            font-size: 12px;
            background-color: #ff0001;
            color: #fff;
          }
        }
      }
    }

    .hot_list {
      width: 370px;
      background-color: #fff;
      margin-top: 20px;

      .hot_top {
        width: 100%;
        height: 34px;
        line-height: 34px;
        padding-left: 15px;
        box-sizing: border-box;
        border-left: 5px solid #0199ff;
        font-size: 18px;
        color: #0199ff;
      }

      .hot_body {
        width: 100%;
        padding: 20px;
        box-sizing: border-box;

        .first {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: space-between;
          line-height: 2.5;
        }

        .hot_left {
          color: #333;
          font-size: 18px;
          display: flex;
          align-items: center;

          .hot_title {
            width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .index {
            width: 20px;
            height: 20px;
            background-color: #0199ff;
            color: #fff;
            font-size: 12px;
            text-align: center;
            line-height: 20px;
            margin-right: 10px;
          }

          .index2 {
            background-color: #e9e9e9;
            color: #999;
          }
        }

        .hot_right {
          font-size: 16px;
          color: #999;
        }
      }
    }
  }

  .talk_right {
    width: 805px;
  }
}
</style>
